module.exports = __webpack_public_path__ + "fonts/174cbcd40a201ec3577bf92004d48c55.txt";